import { StackScreenProps } from "@react-navigation/stack";
import { useCallback, useEffect, useMemo, useState } from "react";
import { CartItemRootParmList } from "../../../../types";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { useActiveCartItem } from "../CartItemModalRootScreen/hooks";
import { TextField, Page, Button } from "@towersystems/roam-common-native";

export type EditSerialNumberScreenProps = StackScreenProps<
  CartItemRootParmList,
  "EditSerialNumberScreen"
>;

export const EditSerialNumberScreen = ({
  navigation,
  route,
}: EditSerialNumberScreenProps) => {
  const { item } = useActiveCartItem();

  const shouldFocus = useHasTransitionEnded(navigation);
  const [value, setValue] = useState(item.serialNumber || "");

  const isDirty = useMemo(() => {
    if (item?.serialNumber === undefined) {
      return value !== "";
    } else {
      return value !== item.serialNumber;
    }
  }, [value, item]);

  const isValid = useMemo(() => {
    return value.length >= 1;
  }, [value]);

  const handleOnSave = useCallback(async () => {
    if (isDirty && isValid && item) {
      item
        .updateSerialNumber(value)
        .then(() => navigation.goBack())
        .catch((err) => console.log(err));
    }
  }, [item, isValid, isDirty, value]);

  useEffect(() => {
    const disabled = !isDirty || !isValid;
    navigation.setOptions({
      title: "Edit Serial Number",
      headerRight: ({}) => (
        <Button
          label="Save"
          isAction
          disabled={disabled}
          onPress={handleOnSave}
          size="compact"
        ></Button>
      ),
    });
  }, [isValid, isDirty, handleOnSave]);

  return (
    <Page scrollable={false} cover>
      <TextField
        placeholder="Serial number"
        value={value}
        onChangeText={(v) => setValue(v)}
        autoFocus={shouldFocus}
        validationMessage={
          isValid ? undefined : "Please enter a valid serial number"
        }
      />
    </Page>
  );
};
